import { useState } from 'react';
import Layout from '../../reservation/components/Layout';
import { LoginForm } from './LoginForm';

export enum PageName {
  LoginForm = 'LOGIN_FORM'
}

export const LoginPage = () => {
  const [activePage, setActivePage] = useState(PageName.LoginForm);

  switch (activePage) {
    case PageName.LoginForm:
      return (
        <Layout title="ログイン">
          <LoginForm setActivePage={setActivePage} />
        </Layout>
      );
    default:
      return <></>;
  }
};
